import type { ObjectAny } from '../../types/ObjectAny'
import { queryStringMatcher } from './queryStringMatcher'

export interface queryStringMatcherMapType {
    from: string
    to: string
    defaultValue?: string
    test?: RegExp
    decorator?: (a: string) => any
}

export const urlSearcherParamsMatcher = <T = ObjectAny>(config: queryStringMatcherMapType[]): T => {
    const x = {}
    new URLSearchParams(window.location.search).forEach((v, k) => (x[k] = v))

    return queryStringMatcher<T>(x, config)
}
